/**
 * Zeilenzahl des Grids für die Kopfzeile der Ansichtsseiten (REQ-21 §3).
 *
 * Die Kopfzeile steht über der Tabelle, die Zahl entsteht aber erst beim Laden im Grid.
 * Statt `DataGridProps` (REQ-00 §14) um eine Rückmeldung zu erweitern und alle vier Seiten
 * anzufassen, reicht ein Kontext sie nach oben: `ViewPageFrame` stellt ihn bereit, `DataGrid`
 * schreibt hinein. Ohne Provider — in der Stilvorschau und in den Tests des Grids allein —
 * bleibt das Schreiben wirkungslos.
 */

import { createContext, useContext, useEffect } from 'react';

export interface GridRowCountValue {
  count: number | null;
  /** Eigenschaft mit Funktionswert (keine Methode) — sie wird ungebunden weitergereicht. */
  setCount: (count: number | null) => void;
}

export const GridRowCountContext = createContext<GridRowCountValue | null>(null);

/** Zeilenzahl des Grids; `null`, solange nichts geladen ist oder kein Provider vorhanden ist. */
export function useGridRowCount(): number | null {
  return useContext(GridRowCountContext)?.count ?? null;
}

/** Meldet die Zeilenzahl an die Kopfzeile; ohne Provider wirkungslos. */
export function useReportGridRowCount(count: number | null): void {
  const setCount = useContext(GridRowCountContext)?.setCount;
  useEffect(() => {
    setCount?.(count);
  }, [count, setCount]);
}
